import { render, staticRenderFns } from "./GroupQuestion.vue?vue&type=template&id=c74e803c&"
import script from "./GroupQuestion.vue?vue&type=script&lang=ts&"
export * from "./GroupQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74e803c')) {
      api.createRecord('c74e803c', component.options)
    } else {
      api.reload('c74e803c', component.options)
    }
    module.hot.accept("./GroupQuestion.vue?vue&type=template&id=c74e803c&", function () {
      api.rerender('c74e803c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/GroupQuestion.vue"
export default component.exports